<template>
    <div class="layout-container-box">
        <el-header class="layout-header">
            <Header>
                <template #header-brand>
                    <BreadCrumb :breadList="breadLists" />
                </template>
            </Header>
        </el-header>
        <el-scrollbar class="layout-main-content" id="content_box">
            <div class="pd-20">
                <div class="patent-container">
                    <SearchFilterBar :statusLabels="statusLabels" @statusChange="statusChange" @addClick="handleAdd" @searchClick="handleSearch" />
                    <div class="table-con mg-t-12">
                        <el-scrollbar>
                            <div class="table-container pd-32">
                                <el-table v-loading="tableLoading" :data="tableData" border :max-height="650">
                                    <el-table-column prop="name" label="专利名" />
                                    <el-table-column prop="inventor" label="发明人">
                                        <template #default="scope">
                                            <span class="mg-r-12" v-for="item in scope.row.inventor" :key="item.id">{{ item.name }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="patentee" label="专利权人">
                                        <template #default="scope">
                                            <span class="mg-r-12" v-for="item in scope.row.patentee" :key="item.id">{{ item.name }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="announce_no" label="公开号" />
                                    <el-table-column width="120" prop="announce_time" label="公开日" />
                                    <el-table-column prop="update_time" label="最近编辑时间" />
                                    <el-table-column prop="publish_time" label="发布时间" />
                                    <el-table-column prop="status" width="80" label="状态">
                                        <template #default="scope">
                                            <span class="status-text primary" v-if="scope.row.status === 1">已发布</span>
                                            <span class="status-text danger" v-else-if="scope.row.status === 2">待完善</span>
                                            <span class="status-text success" v-else-if="scope.row.status === 3">已完善</span>
                                            <span class="status-text info" v-else-if="scope.row.status === 4">已撤回</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="120">
                                        <template #default="scope">
                                            <el-link type="primary" class="mg-r-12" @click="toPage('PatentDetail', {id: scope.row.id})">详情</el-link>
                                            <el-link type="primary" class="mg-r-12" v-if="scope.row.status === 1" @click="coopClick(scope.row.id, 4)">撤回</el-link>
                                            <el-link type="primary" v-if="[3, 4].includes(scope.row.status)" @click="coopClick(scope.row.id, 1)">发布</el-link>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="table-pagination-row mg-t-24">
                                    <el-pagination
                                        background
                                        :currentPage="paginationData.current"
                                        :page-sizes="paginationData.pageSize"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="paginationData.total"
                                        @size-change="handleSizeChange"
                                        @current-change="handleCurrentChange"
                                    >
                                    </el-pagination>
                                </div>
                            </div>
                        </el-scrollbar>
                    </div>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
import Header from '../../../Layout/components/Header.vue';
import BreadCrumb from '../../../components/BreadCrumb/index.vue';
import SearchFilterBar from '../../../components/SearchFilterBar/index.vue'
import { ref, onMounted, onBeforeMount } from 'vue'
import { useRouter } from 'vue-router'
import { Ajax, MessageTips } from '../../../utils'
export default {
    components: {
        SearchFilterBar,
        Header,
        BreadCrumb
    },
    setup() {
        const breadListsRef = ref([
            {
                name: '专利'
            }
        ])
        const tableLoadingRef = ref(false)
        const router = useRouter();
        const searchValRef = ref('')
        const statusRef = ref(0)
        const statusLabelsRef = ref([
            {
                name: "全部",
                value: 0,
            },
            {
                name: "已发布",
                value: 1,
            },
            {
                name: "已完善",
                value: 3,
            },
            {
                name: "待完善",
                value: 2,
            },
            {
                name: "已撤回",
                value: 4,
            } 
        ]);
        // 查询
        const handleSearch = valObj => {
            searchValRef.value = valObj.searchValue;
            getList();
        }
        const statusChange = status => {
            statusRef.value = status;
            getList();
        }
        // 新增
        const handleAdd = (e) => {
            router.push({
                name: 'CreatePatent'
            })
        };
        // 表格数据
        const tableDataRef = ref([])
        // 页码
        let paginationDataRef = ref({
            current: 1,
            pageSize: [10, 20, 50],
            page_size: 10,
            total: 0
        });
        const handleSizeChange = e => {
            paginationDataRef.value.page_size = e;
            getList();
        }
        const handleCurrentChange = e => {
            paginationDataRef.value.current = e;
            getList();
        }

        const getList = () => {
            tableLoadingRef.value = true;
            Ajax.GET({
                url: '/admin/patent',
                params: {
                    name: searchValRef.value,
                    status: statusRef.value || undefined,
                    page: paginationDataRef.value.current,
                    page_size: paginationDataRef.value.page_size
                }
            }).then(res => {
                tableLoadingRef.value = false;
                if(res.data.code === 200) {
                    tableDataRef.value = res.data.data.list;
                    paginationDataRef.value.total=res.data.data.page_info.total
                    console.log(tableDataRef.value, 'value')
                }
            })
        }
        onBeforeMount(() => {
            getList();
        })

        const toPage = (name, query) => {
            router.push({
                name,
                query
            })
        }

        const coopClick = (id, status) => {
            Ajax.POST({
                url: '/admin/patent/status',
                data: {
                    id, status
                }
            }).then(res => {
                if(res.data.code === 200) {
                    MessageTips.success('操作成功')
                    getList()
                }else {
                    MessageTips.error(res.data.msg)
                }
            })
        }
        
        return {
            breadLists: breadListsRef,
            tableLoading: tableLoadingRef,
            handleAdd,
            statusChange,
            handleSearch,
            tableData: tableDataRef,
            paginationData: paginationDataRef,
            handleSizeChange,
            handleCurrentChange,
            statusLabels: statusLabelsRef,
            toPage,
            coopClick
        }
    }
};
</script>

<style lang="less" scoped>
    .patent-container {
        height: 100%;
        .table-pagination-row {
            display: flex;
            justify-content: flex-end;
        }
        .table-con {
            height: 100%;
            max-height: calc(100% - 66px - 12px);
            background-color: #fff;
        }
        .status-text {
            font-size: 14px;
            &.primary {
                color: #409eff;
            }
            &.success {
                color: #67c23a;
            }
            &.danger {
                color: #f56c6c;
            }
            &.info {
                color: #909399;
            }
        }
    }
</style>